import { render, staticRenderFns } from "./AuthorizationsReject.vue?vue&type=template&id=c20d7a9c&"
import script from "./AuthorizationsReject.vue?vue&type=script&lang=js&"
export * from "./AuthorizationsReject.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationsReject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports